class AdvertInlinePageController {
  constructor(AdvertService, AlertService, LoaderService) {
    this.AdvertService = AdvertService;
    this.AlertService = AlertService;
    this.LoaderService = LoaderService;
  }

  $onInit() {
    var self = this;
    self.adverts = [];
    self.LoaderService.start();
    self.AdvertService
      .getAllInlineAdverts()
      .then(adverts => (self.adverts = adverts))
      .catch(error =>
        self.AlertService.error('There was a problem getting the Adverts')
      )
      .finally(() => self.LoaderService.stop());
  }
}
AdvertInlinePageController.$inject = [
  'AdvertService',
  'AlertService',
  'LoaderService'
];
export default AdvertInlinePageController;
